var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0a4 4 0 110 8 4 4 0 010-8z",
    fill: "var(--kf-color-gray-700)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 .889A3.111 3.111 0 104 7.11 3.111 3.111 0 004 .89z",
    fill: "var(--kf-color-white)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.778c.218 0 .4.157.437.364l.007.08v1.334h1.334c.218 0 .4.157.437.364l.007.08c0 .218-.157.4-.364.437l-.08.007H4a.445.445 0 01-.437-.364L3.556 4V2.222c0-.245.199-.444.444-.444z",
    fill: "var(--kf-color-gray-700)"
  })));
}
export default SvgClock;